import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslocoLoader } from '@jsverse/transloco';
import { map } from 'rxjs';
import { API_BASE_URL, TRANSLATIONS_BASE_URL } from '../utils';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);
  private apiBaseUrl = inject(API_BASE_URL);
  private translationsBaseUrl =
    inject(TRANSLATIONS_BASE_URL, { optional: true }) ?? this.apiBaseUrl;

  getTranslation(lang: string) {
    return this.http
      .get<{ result: string }>(
        `${this.translationsBaseUrl}sptranslations/json/${lang}`,
      )
      .pipe(
        map((el) => {
          return JSON.parse(el.result);
        }),
      );
  }
}
